<template>
  <span
    v-if="!inXL"
    class="logout"
    @click="
      $util.clickStat(`GWSY/WDYX/ZX`, `官网首页/我的游戏/注销`)
      $store.commit('logout')
    "
    >{{ txt }}</span
  >
</template>

<script>
export default {
  props: {
    txt: {
      type: String,
      default: '注销'
    }
  },
  data() {
    return {
      inXL: false
    }
  },
  created() {
    if (process.client) {
      this.inXL = xlQuickLogin.isTbcClient()
    }
  }
}
</script>
